<template>
  <div class="card_container">
    <a-avatar
      @click="viewProfile(people)"
      :style="{
        color: ' #ffffff !important',
        'background-color': people.url ? '' : getAvatarColor(people.id)
      }"
      :size="70"
      :src="people.url"
      class="text-capitalize profile_avatar"
      alt="profile"
    >
      {{
        people.firstName
          ? people.firstName[0]
          : people.display_name
          ? people.display_name[0]
          : people.first_name[0]
      }}
    </a-avatar>
    <div class="divider" />
    <div class="right_items">
      <div
        class="d-inline-block text-left ml-2 align-self-center overflow-hidden"
        style="flex: 1"
      >
        <p
          class=" bold-text cp"
          :style="{
            color: '#0F1734',
            'font-weight': '700',
            'font-size': '20px',
            'line-height': '30px',
            'margin-bottom': '4.5px'
          }"
          @click="viewProfile(people)"
        >
          {{ people.display_name }}
        </p>
        <p
          :style="{
            color: '#94A3B8',
            'font-weight': '700',
            'font-size': '14px',
            'line-height': '21px'
          }"
          v-if="people.location && people.location[0].state"
          class="m-0 doc-loc"
        >
          <img
            src="../../assets/images/addphy-location.png"
            :style="{
              marginBottom: '3px',
              paddingRight: '6.5px'
            }"
            alt="location icon"
          />
          {{ people.location[0].city }},
          {{ people.location[0].state }}
        </p>
        <p
          :style="{
            color: '#0F1734',
            'font-size': '14px',
            'line-height': '21px',
            'font-weight': 'bold',
            'margin-top': '4.5px'
          }"
        >
          {{ people.circle_member }} circle members
        </p>
        <a-button
          :style="{
            background: getPrimaryColor()
          }"
          :loading="loadingbtn === people.id && loadingrole === people.role"
          class=" font-white primary-button profile-btn profile_button_mobile"
          style="flex: 1"
          @click="viewProfile(people)"
        >
          View Profile
        </a-button>
      </div>
      <a-button
        :style="{
          background: getPrimaryColor()
        }"
        :loading="loadingbtn === people.id && loadingrole === people.role"
        class=" font-white primary-button profile-btn profile_button"
        @click="viewProfile(people)"
      >
        View Profile
      </a-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdvocateCard",
  data() {
    return {
      loadingbtn: false
    };
  },
  props: {
    people: Object
  },

  components: {},

  methods: {
    viewProfile(user) {
      this.loadingbtn = user.id;
      this.loadingrole = user.role;
      if (
        user.id === this.authUser.user.id &&
        user.role === this.authUser.user.role
      ) {
        this.routeToAuthProfile(this.authUser.user.role);
        this.loadingbtn = false;
        this.loadingrole = false;
      } else {
        this.$store.commit("User/setViewUser", {
          data: { ...this.viewUser, isDirectory: false }
        });
        this.loadingbtn = false;
        this.loadingrole = false;
        switch (user.role) {
          case "doctor":
            this.$router
              .push({
                name: "ViewDoctorUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          case "patient":
            this.$router
              .push({
                name: "ViewPatientUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          case "caregiver":
            this.$router
              .push({
                name: "ViewPatientUpdates",
                params: { id: user.id, role: "caregiver" }
              })
              .catch(() => {});
            break;
          case "advocate":
            this.$router
              .push({
                name: "ViewAdvocateUpdates",
                params: { id: user.id }
              })
              .catch(() => {});
            break;
          default:
            break;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.card_container {
  border: 1px solid #e2e8f0;
  width: 100%;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  display: flex;
  min-height: 159px;
}
.profile_avatar {
  margin: 20px 30px;
  min-width: 70px;
  @media screen and (max-width: 700px) {
    margin: 20px 20px;
  }
}
.divider {
  width: 1px;
  background-color: #cbd5e1;
}
.right_items {
  display: flex;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  margin: 20px 20px;
  margin-left: 15px;
}
.profile_button {
  font-size: 14px;
  border-radius: 6px;
  padding: 12px 24px;
  margin: 10px 25px;
  @media screen and (max-width: 700px) {
    display: none;
  }
}
.profile_button_mobile {
  font-size: 14px;
  border-radius: 6px;
  padding: 12px 24px;
  width: 100%;
  justify-content: center;
  @media screen and (min-width: 701px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/AdvocateCard.vue